import { render, staticRenderFns } from "./GoNext.vue?vue&type=template&id=3676c20a&scoped=true&"
import script from "./GoNext.vue?vue&type=script&lang=js&"
export * from "./GoNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3676c20a",
  null
  
)

export default component.exports